import React, {useEffect, useRef, useState} from "react";
import {TextField} from "@material-ui/core";
import { useTheme } from "@material-ui/styles"
import { useSelector } from "react-redux"
import config from "../../config"
import { muiNoOutline } from "../../utils"

export default function Textarea({formik, label, name, type, rows = 5, ...rest}) {
  const { theme: { bgColors, colors } } = useTheme()
  const [open, setOpen] = useState(false)
  const node = useRef(null)
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const classes = muiNoOutline()

  useEffect(() => {
    document.addEventListener("mousedown", handleOnClick, false)
    return document.addEventListener("mousedown", handleOnClick, false)
  }, [node])

  function handleOnClick(e) {
    if (node?.current?.contains(e.target)) {
      setOpen(true)
      return
    }
    setOpen(false)
  }

  return (
    formik ?
      <TextField
        ref={node}
        fullWidth
        name={name}
        InputProps={{ style: { color: colors.colorText, backgroundColor: bgColors.bgPrimary200, resize: 'vertical'  }}}
        InputLabelProps={{ style: { color: colors.colorText }}}
        classes={isContrast ? { root: classes.root } : {}}
        type={type ? type : "text"}
        {...rest}
        label={label}
        variant="outlined"
        multiline
        onClick={() => setOpen(true)}
        value={formik?.values[name] && typeof formik?.values[name] === 'object' ? JSON.stringify(formik?.values[name], undefined, 4) : formik?.values[name]}
        onChange={formik.handleChange}
        minRows={open ? rows : 1}
        style={{transition: ".3s easy-in"}}
        error={formik.touched[name] && Boolean(formik.errors[name])}
        helperText={formik.touched[name] && formik.errors[name]}
      /> :
      <TextField
        ref={node}
        fullWidth
        label={label}
        multiline
        minRows={open ? rows : 1}
        variant="outlined"
        style={{transition: ".3s easy-in"}}
        onClick={() => setOpen(true)}
      />
  )
}